/* this file is transformed by vux-loader */
/* eslint-disable */
var mode = 0; // 0 : 内测 ， 1：开发，2：本地 , 3 mock

var isDev = process.env.NODE_ENV === 'development';
var prefix = ['/api/', '/dev/', '/local/', '/mock'][mode]; // const target = 'http://192.168.1.10:8080/'
// const target = 'http://asapp.huadianswg.cn'

var target = '';
var target1 = 'http://huadianapp.com/'; // const target2 = 'http://192.168.1.10:8087/'

var target2 = 'http://asapp.huadianswg.cn';
var baseUrl = isDev ? prefix : target;
var previewUrl = 'https://preview.zhongyifu.cn/onlinePreview';
export { mode, baseUrl, previewUrl, target1, target2 };